


































import { Component, Vue, Prop } from "vue-property-decorator";
import { LivingAppsReportRecord } from "@/types";

@Component
export default class ReportDetailData extends Vue {
  // public report?: LivingAppsReport;
  @Prop() public report?: LivingAppsReportRecord;

  public getImageUrl(name: string): string | null {
    if (this.report) {
      const img = this.report[name];
      if (img.value) {
        if (img && img.value instanceof File) {
          return URL.createObjectURL(img.value);
        } else {
          if (img.value.url) {
            return "https://ci04.ci.xist4c.de" + img.value.url;
          }
        }
      }
    }
    return null;
  }
}
